import { render, staticRenderFns } from "./organization-social-form.vue?vue&type=template&id=16b71ae2&"
import script from "./organization-social-form.vue?vue&type=script&lang=js&"
export * from "./organization-social-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports